import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
export const getMasterColumns = (editData, deleteData) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editData(row);
              }}
            />
            <DeleteIcon
              color={row.REFERENCED_USER > 0  ? "disabled" : "action"}
              onClick={() => {
                deleteData(row.ROLE_ID, row.REFERENCED_USER);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "ROLE_ID",
      text: "Role ID",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "ROLE_DESC",
      text: "Role Description",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "ACTIVE",
      text: "Active",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "REFERENCED_USER",
      text: "Referenced Users",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
  ];
  return columns;
};
